// Учётные записи в интерфейсе: вход и регистрация (AuthRoot - корень SPA, main.tsx), меню учётной записи, смена
// пароля, профиль для титула, повторный вход без потери текста, плашка «чужой отчёт», скрытие «сил
// компьютера-сервера» (Открыть в Word, Показать в папке, картинки из временных файлов Word) по возможностям
// пользователя (GET /api/auth/me -> capabilities). Панель администрирования - features/admin.
import type { RegistryApi } from '../../core/registry';
import { saveNow } from '../../core/project';
import { writeBackupNow } from '../shell/backup';
import { setupAdmin } from '../admin';
import { ChangePasswordDialog, SessionsDialog } from './account';
import { setupReadOnly, SubscriptionDialog, TelegramDialog } from './billing';
import { McpDialog } from './mcp';
import { ReferralsDialog } from './referrals';
import { logout, onSessionLost, setForeign } from './session';
import './auth.css';

export default function setup(r: RegistryApi) {
  r.dialogs.add({ id: 'auth.password', component: ChangePasswordDialog });
  r.dialogs.add({ id: 'auth.sessions', component: SessionsDialog });
  r.dialogs.add({ id: 'auth.mcp', component: McpDialog });
  r.dialogs.add({ id: 'auth.subscription', component: SubscriptionDialog });
  r.dialogs.add({ id: 'auth.telegram', component: TelegramDialog });
  r.dialogs.add({ id: 'auth.referrals', component: ReferralsDialog });
  r.commands.add({ id: 'account.subscription', title: 'Подписка', description: 'Срок, тарифы, код активации', icon: 'star',
    run: (c) => c.openDialog('auth.subscription', {}) });
  setupReadOnly();
  r.commands.add({ id: 'account.mcp', title: 'Подключить нейросеть', description: 'Claude, ChatGPT, Cursor пишут отчёт, сайт оформляет по СТО (MCP)', icon: 'sparkles',
    run: (c) => c.openDialog('auth.mcp', {}) });
  r.commands.add({ id: 'account.password', title: 'Сменить пароль', icon: 'key', run: (c) => c.openDialog('auth.password', {}) });
  r.commands.add({ id: 'account.profile', title: 'Мой профиль', description: 'Данные для титула, руководители, дисциплины', icon: 'student',
    run: (c) => c.openDialog('sto.profile', {}) });
  r.commands.add({ id: 'account.logout', title: 'Выйти из учётной записи', icon: 'logout', run: () => logout(() => saveNow()) });
  // сессия потеряна посреди работы - копия несохранённого сразу в браузер (на случай, если вкладку закроют)
  onSessionLost(() => writeBackupNow());
  r.events.on('project:opened', ({ id, report }: any) => setForeign(id, report));
  r.events.on('project:closed', () => setForeign(null));
  setupAdmin(r);
}
